<template>
  <centered-layout>
    <template v-slot:main>
      <div class="position-absolute d-flex align-content-center" style="top: 15%;">
        <login @login="login($event)"></login>
      </div>
    </template>
  </centered-layout>
</template>

<script>
import CenteredLayout from "@/layouts/CenteredLayout";
import Login from "@/components/Login";

export default {
  methods: {
    async login(credentials) {
      try {
        await this.$store.dispatch('login', credentials)
        await this.$router.push('/')
      } catch (error) {
        await this.$store.dispatch('showMessage', {
          message: error.message,
          type: 'warning'
        })
      }
    }
  },
  components: {Login, CenteredLayout}
}
</script>
